var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"employee-list__state"},[_c('div',{staticClass:"text--secondary"},[_vm._v(" "+_vm._s(_vm.$t("auth.teamMode.employeeList.loadingText"))+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }